<dv-form-wrapper>
  <dv-form vtFormTranslate [formGroup]="formGroup" [elements]="elements" />
  <div class="route-network-edit-buttons">
    <dv-button
      [icon]="'map_marker_radius'"
      (click)="editPoi()"
      [disabled]="entityId === NEW_ENTITY_ROUTE_PARAM"
      >{{ 'RouteNetwork.EditRouteNetworkMarker' | translate }}</dv-button
    >
    <dv-button
      [icon]="'draw_polyline'"
      (click)="editRouteNetwork()"
      [disabled]="entityId === NEW_ENTITY_ROUTE_PARAM"
      >{{ 'RouteNetwork.EditRouteNetwork' | translate }}</dv-button
    >
  </div></dv-form-wrapper
>
<dv-save-panel
  labelCancel=""
  [disableSave]="!formGroup.dirty || !formGroup.valid"
  labelSave="{{ 'General.Save' | translate }}"
  (save)="onSave()">
</dv-save-panel>
